import React from 'react';
import * as CONF from "../../../common/config";

const SignArea = ({ data }) => {

    const signUrl = (path) => {
        if (!path) return '';
        return `${CONF.imgPrefix}${path}`;
    };

    const checklist = data.checklist || [];

    const allPassed = checklist.length > 0 && checklist.every(item => item.result === 'yes');

    // 从checklist中计算整改数量
    // rectifyType: 'immediate' = 立即已整改，'deadline' = 限期整改
    const dangerItems = checklist.filter(item => item.result === 'no');
    const immediateCount = dangerItems.filter(item => item.rectifyType === 'immediate').length;
    const deadlineItems = dangerItems.filter(item => item.rectifyType === 'deadline' && item.deadline);
    const maxDeadline = deadlineItems.length > 0
        ? deadlineItems.map(item => item.deadline).sort().pop()
        : null;

    return (
        <div className="sign-section">

            <table className="sign-info-table">
                <tbody>

                    <tr>
                        <td className="label-cell">
                            检查结果
                        </td>

                        <td colSpan="3">
                            {data.result === 'yes'
                                ? '符合消防安全要求'
                                : '存在消防安全隐患'}
                        </td>
                    </tr>

                    <tr>
                        <td className="label-cell">
                            隐患数量
                        </td>

                        <td>
                            {dangerItems.length || 0}项
                        </td>

                        <td className="label-cell">
                            立即整改
                        </td>

                        <td>
                            {immediateCount || 0}项
                        </td>
                    </tr>

                    <tr>
                        <td className="label-cell">
                            整改期限
                        </td>

                        <td colSpan="3">
                            {maxDeadline || '无'}
                        </td>
                    </tr>

                    <tr>
                        <td className="label-cell">
                            隐患内容
                        </td>

                        <td colSpan="3">
                            {allPassed ? '无' : (data.dangerItems || '无')}
                        </td>
                    </tr>

                    <tr>
                        <td className="label-cell">
                            整改意见
                        </td>

                        <td colSpan="3">
                            {data.rectifyNotice}
                        </td>
                    </tr>

                </tbody>
            </table>

            {/* <div className="signature-row">

                <div className="signature-box">

                    <div className="sign-title">
                        现场负责人签字
                    </div>

                    {
                        data.siteManagerSign &&
                        (
                            <img
                                src={signUrl(data.siteManagerSign)}
                                alt=""
                                className="sign-image"
                            />
                        )
                    }

                    <div className="sign-name">
                        {data.siteManager}
                    </div>

                </div>

                <div className="signature-box">

                    <div className="sign-title">
                        排查人签字
                    </div>

                    {
                        data.inspectorSign &&
                        (
                            <img
                                src={signUrl(data.inspectorSign)}
                                alt=""
                                className="sign-image"
                            />
                        )
                    }

                    <div className="sign-name">
                        {data.inspector}
                    </div>

                </div>

            </div> */}

            <table className="sign-table">
                <tbody>

                    <tr>
                        <td className="sign-cell">
                            <div className="sign-inline">
                                <span>现场负责人（签字）：</span>
                                {
                                    data.siteManagerSign && (
                                        <img
                                            src={signUrl(data.siteManagerSign)}
                                            alt=""
                                            className="sign-image"
                                        />
                                    )
                                }
                            </div>
                        </td>

                        <td className="sign-cell">
                            <div className="sign-inline">

                                <span>排查人（签字）：</span>

                                {
                                    data.inspectorSign && (
                                        <img
                                            src={signUrl(data.inspectorSign)}
                                            alt=""
                                            className="sign-image"
                                        />
                                    )
                                }
                                {
                                    data.inspector2Sign && (
                                        <img
                                            src={signUrl(data.inspector2Sign)}
                                            alt=""
                                            className="sign-image"
                                        />
                                    )
                                }

                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td
                            colSpan={2}
                            className="date-cell"
                        >
                            排查时间：
                            {data.createdAt}
                        </td>
                    </tr>

                </tbody>
            </table>
            {/* <div className="inspection-date">
                检查日期：
                {data.inspectionDate}
            </div> */}
        </div>
    );
};

export default SignArea;